import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function RegisterPage() {
  const { register, formatApiError } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (password.length < 6) {
      setErr("Password must be at least 6 characters.");
      return;
    }
    setLoading(true);
    try {
      await register(email.trim(), password, name.trim());
      navigate("/");
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto my-16">
      <div className="overline text-[#C5A059] mb-3 text-center">Join the station</div>
      <h1 className="font-serif text-4xl text-center text-[#FDFBF7] tracking-tight mb-2">Create your account</h1>
      <p className="text-center text-[#A1A4AB] mb-8">Build playlists, save favorites, and submit your own music.</p>
      <form onSubmit={submit} className="space-y-4 card-surface p-8" data-testid="register-form">
        <div>
          <label className="text-sm text-[#A1A4AB] mb-2 block">Name</label>
          <input required value={name} onChange={(e) => setName(e.target.value)} className="input-lux" data-testid="register-name-input" placeholder="Your name" />
        </div>
        <div>
          <label className="text-sm text-[#A1A4AB] mb-2 block">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-lux" data-testid="register-email-input" placeholder="you@example.com" />
        </div>
        <div>
          <label className="text-sm text-[#A1A4AB] mb-2 block">Password</label>
          <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="input-lux" data-testid="register-password-input" placeholder="Min 6 characters" />
        </div>
        {err && <div className="text-sm text-red-400" data-testid="register-error">{err}</div>}
        <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="register-submit-btn">
          {loading ? "Creating..." : "Create account"}
        </button>
        <div className="text-center text-sm text-[#A1A4AB] pt-2">
          Already a member?{" "}
          <Link to="/login" className="text-[#C5A059] hover:text-[#DCC286]" data-testid="register-to-login-link">Sign in</Link>
        </div>
      </form>
    </div>
  );
}
